import { render, staticRenderFns } from "./ShortNIM_addon.vue?vue&type=template&id=9bdb2f1c&scoped=true&"
import script from "./ShortNIM_addon.vue?vue&type=script&lang=js&"
export * from "./ShortNIM_addon.vue?vue&type=script&lang=js&"
import style0 from "./ShortNIM_addon.vue?vue&type=style&index=0&id=9bdb2f1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdb2f1c",
  null
  
)

export default component.exports